'use client';

import React, { FC } from 'react';

import PartFeedback from '@/components/part-feedback';
import PartOrderSection from '@/components/part-order-section';
import PartResults from '@/components/part-results';
import PartPageBanner from '@/components/UI/part-page-banner';
import PartServicesDecor from '@/components/UI/part-services-decor';
import { IAboutUsFeatures } from '@/contentful/utils/aboutUsFeatures';
import { ICategoryPage } from '@/contentful/utils/categoryPage';
import { IDivider } from '@/contentful/utils/divider';
import { IForm } from '@/contentful/utils/form';
import { IListItem } from '@/contentful/utils/listItem';
import { IReview } from '@/contentful/utils/reviews';
import { useLanguage } from '@/context/LanguageContext';

import PartFaqAboutUs from './part-faq-about-us';
import PartFeatures from './part-features';
import PartReviews from './part-reviews';

interface IPartAboutUsView {
  data: {
    aboutUsPages: ICategoryPage[];
    dividers: IDivider[];
    listItemsEffects: IListItem[];
    aboutUsFeatures: IAboutUsFeatures[];
    listItemsFaqs: IListItem[];
    reviews: IReview[],
    forms: IForm[],
  };
}

const PageAboutUsView: FC<IPartAboutUsView> = ({ data }) => {
  const { language } = useLanguage();
  const aboutUsPage = data.aboutUsPages.filter(
    (item) => item.lang === language,
  )[0];
  const aboutUsDividers = data.dividers.filter(
    (item) => item.lang === language,
  )[0];
  const aboutUsResults = data.listItemsEffects.filter(
    (item) => item.lang === language,
  );
  const aboutUsFeatures = data.aboutUsFeatures.filter(
    (item) => item.lang === language,
  )[0];

  const aboutUsFaq = data.listItemsFaqs.filter(
    (item) => item.lang === language,
  );

  const aboutUsForm = data.forms.filter((item) => item.lang === language)[0];

  const aboutUsReviews = data.reviews.filter((item) => item.lang === language);

  const aboutUsPageBannerData = {
    title: aboutUsPage.title,
    imageDesktop: aboutUsPage.imageDesktop,
    imageMobile: aboutUsPage.imageMobile,
  };

  const aboutUsPageFeatures = {
    category: aboutUsPage.sectionFirstCategory,
    title: aboutUsPage.sectionFirstTitle,
    image: aboutUsPage.sectionFirstImage,
    features: aboutUsFeatures,
  };

  const aboutUsPageDivider = {
    lang: language,
    title: aboutUsDividers.title,
    description: aboutUsDividers.description,
    buttonName: aboutUsDividers.buttonName,
    slug: aboutUsDividers.slug,
  };

  const aboutUsPageFaq = {
    category: aboutUsPage.sectionSecondCategory,
    title: aboutUsPage.sectionSecondTitle,
    image: aboutUsPage.sectionSecondImage,
    content: aboutUsPage.sectionSecondContent,
    faqs: aboutUsFaq,

  };

  const aboutUsPageReviews = {
    category: aboutUsPage.sectionThirdCategory,
    title: aboutUsPage.sectionThirdTitle,
    reviews: aboutUsReviews,
  };

  return (
    <>
      <PartPageBanner data={aboutUsPageBannerData} category />
      <PartFeatures data={aboutUsPageFeatures} />
      <PartOrderSection data={aboutUsPageDivider} />
      <PartFaqAboutUs data={aboutUsPageFaq} />
      <PartResults data={aboutUsResults} />
      <PartReviews data={aboutUsPageReviews} />
      <PartFeedback data={aboutUsForm} />
      <PartServicesDecor />
    </>
  );
};

export default PageAboutUsView;
